import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Popup } from './popup';

@Injectable()
export class PopupService {

    private requirePopupSource = new Subject<Popup>();
    private acceptPopupSource = new Subject<Popup>();
    private deletePopupSource = new Subject<Popup>();
    private updatePopupSource = new Subject<Popup>();
    // Observable string sources
    private tasks = new Subject<any>();
    // Observable string streams
    tasksConfirmed$ = this.tasks.asObservable();

    requirePopup$ = this.requirePopupSource.asObservable();
    accept = this.acceptPopupSource.asObservable();
    delete = this.deletePopupSource.asObservable();
    update = this.updatePopupSource.asObservable();

    confirm(popup: Popup) {
        this.requirePopupSource.next(popup);
        return this;
    }

    onAccept() {
        this.acceptPopupSource.next();
    }

    onDelete() {
        this.deletePopupSource.next();
    }

    onUpdate() {
        this.updatePopupSource.next();
    }

    postTask(task: any) {

        this.tasks.next(task);
    }

}
